<template>
  <div class="learnDefault conten column cen-start conten bg-white">
    <section v-if="isPay" class="text-center">
      <span class="ilbk payImg text-center">
        <img src="../../assets/imgs/paySuccess.png" alt="" />
      </span>
      <p class="ft16 gray-2 successText bold">支付成功~</p>
      <p class="gray-6 ft12 margin25_bottom">
        课程已放入您的学习中心，感谢您的支持，祝你学习愉快
      </p>
      <div class="row cen-between">
        <span
          @click="goHome"
          class="btn courseBtn text-center ilbk ft16 orangered"
          >回到首页</span
        >
        <span @click="golearn" class="btn homeBtn text-center ilbk ft16 white"
          >去看课</span
        >
      </div>
    </section>
    <section v-else class="text-center">
      <span class="ilbk payImg text-center">
        <img src="../../assets/imgs/paySuccess.png" alt="" />
      </span>
      <p class="ft16 gray-2 text bold">支付失败~</p>
      <span @click="goHome" class="btn buyBtn text-center ilbk ft16 white"
        >重新购买</span
      >
    </section>
    <Agreement ref="agreement" :cid="cid" />
  </div>
</template>

<script>
import Agreement from "@/components/common/agreement/agreement"

export default {
  components:{
    Agreement
  },
  name: "learnDefault",
  data() {
    return {
      isPay: true,
      cid:""
    };
  },
  created() {
    this.cid = this.$store.state.Pay.payCid
    this.isPay = this.$route.query.isPay;
  },
  methods: {
    goHome() {
      this.$router.push({
        path: "/index",
      });
    },
    golearn() {
      let cid = this.$store.state.Pay.payCid;
      if (cid != null && cid != undefined && cid != "") {
        let data = {
          cid : this.cid,
          uid : this.uid()
        }
        this.ApiNew.Mine.userIfSignAgreement(data).then(res => {
          if(res.retuCode == 5000) {
            this.$router.push({
              path: "/chapter",
              query: {
                cid
              },
            });
          } else if(res.retuCode == 5022 || res.retuCode == 5023) { // 用户未签署协议
            this.cid = cid
            this.$refs.agreement.agreementName = res.data.name
            this.$refs.agreement.agreementId = res.data.agreementid
            this.$refs.agreement.show = true
          }
        }).catch(() => {
            this.$router.push({
            path: "/chapter",
            query: {
              cid,
            },
          });
        })
        
      } else {
        this.$router.push({
          path: "/learning",
        });
      }
    },
  },
};
</script>
<style scoped lang="less">
.learnDefault {
  width: 100%;
  padding-top: 54/20rem;
  .payImg {
    width: 166/20rem;
    height: 95/20rem;
  }
  .text {
    padding: 34/20rem 0 43/20rem;
  }
  .successText {
    padding: 34/20rem 0 20/20rem;
  }
  .margin25_bottom {
    margin-bottom: 25/20rem;
  }
  .btn {
    height: 38/20rem;
    line-height: 38/20rem;
    border-radius: 19/20rem;
  }
  .courseBtn {
    width: 130/20rem;
    border: 1px solid rgba(244, 128, 62, 1);
  }
  .homeBtn {
    width: 130/20rem;
    background: linear-gradient(
      90deg,
      rgba(253, 123, 49, 1),
      rgba(240, 130, 67, 1)
    );
    box-shadow: 0px 0px 7/20rem 3px rgba(253, 123, 49, 0.43);
  }
  .buyBtn {
    width: 180/20rem;
    background: linear-gradient(
      90deg,
      rgba(253, 123, 49, 1),
      rgba(240, 130, 67, 1)
    );
    box-shadow: 0px 0px 7/20rem 3px rgba(253, 123, 49, 0.43);
  }
}
</style>
